<div class="main-container">
  <div class="inside-main-container">
    <mat-tab-group color="primary" backgroundColor="light-blue" class="mat-elevation-z8">
      <mat-tab *ngFor="let modCode of modelListCod;index as i;" label="{{title[i]}}">
        <app-flavour-list (modelName)="setTitle($event,i)" [modCode]="modCode"></app-flavour-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
